
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance-coverage",
      function () {
        return require("private-next-pages/insurance-coverage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurance-coverage"])
      });
    }
  